import { render } from "./AppInfo.vue?vue&type=template&id=54520300&scoped=true"
import script from "./AppInfo.vue?vue&type=script&lang=js"
export * from "./AppInfo.vue?vue&type=script&lang=js"

import "./AppInfo.vue?vue&type=style&index=0&id=54520300&scoped=true&lang=css"

import exportComponent from "/home/sergey/projects/tm/calc_furnace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54520300"]])

export default __exports__